import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UserEditInfo } from '../models/user.model';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private baseUrl = 'https://api.futuroacs.com.br/api/user';
  private token = localStorage.getItem('token'); 

  constructor(private http: HttpClient) {}

  editInfos(data: UserEditInfo): Observable<any> {
    const url = `${this.baseUrl}/edit`;

    // Define os cabeçalhos com o token
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${this.token}`, 
    });

    // Faz a requisição POST com os dados e cabeçalhos
    return this.http.post(url, data, { headers });
  }

  getUserPlan(userId: number): Observable<any> {
  const url = `${this.baseUrl}/${userId}/plan`;

  const headers = new HttpHeaders({
    'Content-Type': 'application/json',
    Authorization: `Bearer ${this.token}`,
  });

  return this.http.get(url, { headers });
}
}
